export default "__VITE_ASSET__SH$55N_A__"